namespace Ir.Components.Workbook.WorkbookPreferencesPopover {
    interface IViewModel {
        sideBarConfig: DevExpress.ui.dxSwitch.Properties;
    }

    interface IParams {
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        this.sideBarConfig = {
            value: workbook.workbookConfig.preferences.hideSidebarWhenOpening as any
        };
    }

    let popoverComponent: DevExpress.ui.dxPopover;
    export function show(target) {
        if (popoverComponent == null) {
            let popoverOptions = {
                title: "Workbook Preferences",
                showTitle: true,
                width: 350,
                target: target,
                onInitialized(e) {
                    popoverComponent = e.component;
                    popoverComponent.show();
                }
            } as DevExpress.ui.dxPopover.Properties;

            let $popover = $(`
            <div data-bind="dxPopover: popoverOptions">
                <workbookPreferences></workbookPreferences>
            </div>`);
            $popover.appendTo('body');

            ko.applyBindings({ popoverOptions }, $popover[0]);
        }
        else {
            popoverComponent.show();
        }
        
    }
}